<template>
  <div class="flex-grow-1 d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="billing/cash-flow/refill-and-refunds"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :externalFilters="externalFilters"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h2 class="page-heading mr-auto">Пополнения и возвраты</h2>
        <btn-filters
          :data="data"
          endpoint="billing/cash-flow/refill-and-refunds"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>
    <template v-if="data && data.data">
      <data-table-full-height
        :data="modems"
        @sort-change="sortChange"
        @load-more="loadMore"
        :hasMore="hasMore"
        :loading="loading"
        @filter-change="filterChange"
      >
        <el-table-column prop="organization_name" label="Организация" />
        <el-table-column prop="organization_director" label="Руководитель" />
        <el-table-column prop="status" label="Статус"  width="250" align="center"/>
        <el-table-column prop="sum" label="Сумма"  width="150" align="right"/>
        <el-table-column prop="created_date" label="Дата запроса"  width="200" align="center"/>
        <el-table-column prop="updated_date" label="Дата ответа"  width="200" align="center"/>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        sort: {prop: 'updated_at', order: 'asc'},
        updateList: 0,
        externalFilters: null,
        regionFilters: [],
      }
    },
    computed: {
      modems () {
        return this.data.data
      },
    },
    methods: {
      newModem () {
        this.$root.showModal(EditModal, {id: null, uid: null, newModem: true}).then((value) => {
          if (value) {
            this.modems.unshift({
              id: value.modemId,
              uid: value.uid,
              region: value.region,
            })
          }
        })
      },
      edit (modem) {
        let noCommands = modem.last_command_at === null
        this.$root.showModal(EditModal, {
          id: modem.id,
          currentRegion: modem.region,
          uid: modem.uid,
          noCommands: noCommands,
          number: modem.number,
        }).then((value) => {
          if (value) {
            this.modems.forEach(function (item) {
              if (item.id === value.modemId) {
                item.region = value.region
              }
            })
          }
        })
      },
      loadMore () {
        this.$refs.data.loadMore()
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = {
            prop: sort.prop,
            order,
          }
        } else {
          this.sort = null
        }
      },
      filterChange (filter) {
        this.externalFilters = filter
      },
    },
    asyncComputed: {
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/cash-flow/refills-and-refunds.vue